import React from "react";
import { useLang } from "../context/LanguageContext";
import { LANGUAGES } from "../i18n/translations";

export default function LanguageSwitcher({ compact = false }) {
    const { lang, setLang } = useLang();
    return (
        <div className={`inline-flex items-center gap-1 ${compact ? "" : "rounded-full bg-white/60 backdrop-blur p-1 border border-slate-200/70"}`} data-testid="language-switcher">
            {LANGUAGES.map((l) => (
                <button
                    key={l.code}
                    type="button"
                    onClick={() => setLang(l.code)}
                    data-testid={`lang-${l.code}-button`}
                    className={`px-2.5 py-1 text-xs font-bold tracking-wider rounded-full transition-all ${
                        lang === l.code
                            ? "bg-[#1A365D] text-white shadow-sm"
                            : "text-[#1A365D]/70 hover:text-[#1A365D]"
                    }`}
                >
                    {l.label}
                </button>
            ))}
        </div>
    );
}
